(function(){
  if (window.lumeanisSingleVariantFirstClickFix) return;
  window.lumeanisSingleVariantFirstClickFix = true;

  function getCard(el){
    return el && el.closest ? el.closest('.template-collection .product-item[data-json-product]') : null;
  }

  function getProduct(card){
    if (!card) return null;
    try { return JSON.parse(card.getAttribute('data-json-product')); } catch(e) { return null; }
  }

  function getForm(card, product){
    if (product && product.id) {
      var exact = document.getElementById('product-quick-shop-form-' + product.id);
      if (exact) return exact;
    }
    return card ? card.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], form[id*="quick-shop"], form[id*="product-form"]') : null;
  }

  function getButton(card, clickedButton){
    return clickedButton || (card ? card.querySelector('.card-action button[name="add"], .card-action button[type="submit"], .card-action .button') : null);
  }

  function setButton(button, loading){
    if (!button) return;
    if (loading) {
      if (!button.dataset.lumeanisOldText) button.dataset.lumeanisOldText = button.textContent;
      button.textContent = 'AJOUT AU PANIER...';
      button.disabled = true;
      button.classList.add('is-loading');
    } else {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = button.dataset.lumeanisOldText || 'AJOUTER AU PANIER';
      delete button.dataset.lumeanisOldText;
    }
  }

  function updateCount(cart){
    if (!cart || typeof cart.item_count === 'undefined') return;
    document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count-bubble .text, .header-cart-count, .cart-count').forEach(function(el){
      el.textContent = cart.item_count;
    });
  }

  function openDrawer(){
    window.after_add_to_cart = window.after_add_to_cart || {};
    window.after_add_to_cart.type = 'quick_cart';
    document.body.classList.remove('cart-dropdown-show','add-to-cart-popup-show','halo-add-to-cart-popup-show','popup-cart-show','halo-popup-show');
    var trigger = document.querySelector('[data-cart-sidebar], [data-open-cart-sidebar], .header-cart [data-cart-sidebar], .header-cart, .header__icon--cart, .cart-icon');
    if (trigger) trigger.click();
  }

  function hideSingleVariantPanels(card){
    if (!card) return;
    card.classList.add('lumeanis-single-variant-card');
    card.querySelectorAll('.variants-popup, .card-QuickShop, .card-popup').forEach(function(panel){
      panel.style.display = 'none';
    });
  }

  function addSingleVariant(card, product, button){
    if (!card || !product || !product.variants || product.variants.length !== 1) return;
    var variant = product.variants[0];
    if (!variant || variant.available === false) return;
    if (card.dataset.lumeanisSingleAdding === '1') return;

    card.dataset.lumeanisSingleAdding = '1';
    hideSingleVariantPanels(card);
    setButton(button, true);

    var form = getForm(card, product);
    var fd = form ? new FormData(form) : new FormData();
    fd.set('id', variant.id);
    if (!fd.get('quantity')) fd.set('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
    .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } }); })
    .then(function(r){ return r.json(); })
    .then(function(cart){
      updateCount(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
      document.dispatchEvent(new CustomEvent('halo:cart:refresh', { detail: { cart: cart } }));
      openDrawer();
    })
    .finally(function(){
      card.dataset.lumeanisSingleAdding = '0';
      setButton(button, false);
    });
  }

  document.addEventListener('click', function(e){
    var button = e.target.closest && e.target.closest('.template-collection .card-action button[name="add"], .template-collection .card-action button[type="submit"], .template-collection .card-action .button');
    if (!button) return;

    var card = getCard(button);
    var product = getProduct(card);
    if (!product || !product.variants || product.variants.length !== 1) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    addSingleVariant(card, product, getButton(card, button));
    return false;
  }, true);

  function markCards(){
    document.querySelectorAll('.template-collection .product-item[data-json-product]').forEach(function(card){
      var product = getProduct(card);
      if (product && product.variants && product.variants.length === 1) hideSingleVariantPanels(card);
    });
  }

  document.addEventListener('DOMContentLoaded', markCards);
  document.addEventListener('shopify:section:load', markCards);
  setTimeout(markCards, 300);
  setTimeout(markCards, 1200);
})();
